import React from 'react';
import { Download } from 'lucide-react';
import { IconButton } from "@mui/material";
import SearchInput from '../subComponents/search/SearchInput';
import CustomPagination from '../subComponents/pagination/CustomPagination';
import CustomButton from '../subComponents/buttons/CustomButton';
import ItemsPerPageSelector from '../subComponents/pagination/ItemsPerPageSelector';
import { PERMISSIONS } from '../../Permissions';
import GenericFilter from '../subComponents/Filter/GenericFilters';
import { t } from '../../locales/translate';

const EmployeeHeader = ({
  query,
  handleSearchChange,
  itemsPerPage,
  handleItemsPerPageChange,
  currentPage,
  totalCount,
  totalPages,
  setCurrentPage,
  handleEmployeeDownload,
  permissions,
  handleAddEmployeeClick,
  // Only need these two filter props now
  showFilters,
  toggleFilters
}) => {
  return (
    <div className="employee-header-row">
      <div className="employee-header-left">
        <SearchInput
          placeholder="Search"
          onChange={(e) => handleSearchChange(e.target.value)}
          value={query}
        />
      </div>

      <div className="employee-header-right">
        <div style={{ minWidth: '80px', marginRight: '10px' }}>
          <ItemsPerPageSelector
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
          />
        </div>

        <CustomPagination
          currentPage={currentPage}
          totalItems={totalCount}
          itemsPerPage={itemsPerPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
        />

        <div style={{ paddingRight: '12px' }}>
          <IconButton onClick={handleEmployeeDownload}>
            <Download />
          </IconButton>
        </div>

        {/* Updated to use the new GenericFilter component */}
        <GenericFilter 
          showFilters={showFilters} 
          toggleFilters={toggleFilters} 
        />

        {permissions.includes(PERMISSIONS.CAN_ADD_EMPLOYEE) && (
          <CustomButton
            text={t("addNew")}
            onClick={handleAddEmployeeClick}
          />
        )}
      </div>
    </div>
  );
};

export default EmployeeHeader;